import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <section className="gc-notfound">
    <div className="gc-notfound__inner">
      <span className="gc-notfound__code">404</span>
      <h1 className="gc-notfound__title">Page Not Found</h1>
      <p className="gc-notfound__text">
        お探しのページは見つかりませんでした。<br />
        URLが正しいかご確認ください。
      </p>
      <Link to="/" className="gc-btn">トップページへ戻る</Link>
    </div>
  </section>
);

export default NotFound;
